var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCancel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2670_2669",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2670_2669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 11.1665L12.4165 13.5832C12.5693 13.7359 12.7637 13.8123 12.9998 13.8123C13.2359 13.8123 13.4304 13.7359 13.5832 13.5832C13.7359 13.4304 13.8123 13.2359 13.8123 12.9998C13.8123 12.7637 13.7359 12.5693 13.5832 12.4165L11.1665 9.99984L13.5832 7.58317C13.7359 7.43039 13.8123 7.23595 13.8123 6.99984C13.8123 6.76373 13.7359 6.56928 13.5832 6.4165C13.4304 6.26373 13.2359 6.18734 12.9998 6.18734C12.7637 6.18734 12.5693 6.26373 12.4165 6.4165L9.99984 8.83317L7.58317 6.4165C7.43039 6.26373 7.23595 6.18734 6.99984 6.18734C6.76373 6.18734 6.56928 6.26373 6.4165 6.4165C6.26373 6.56928 6.18734 6.76373 6.18734 6.99984C6.18734 7.23595 6.26373 7.43039 6.4165 7.58317L8.83317 9.99984L6.4165 12.4165C6.26373 12.5693 6.18734 12.7637 6.18734 12.9998C6.18734 13.2359 6.26373 13.4304 6.4165 13.5832C6.56928 13.7359 6.76373 13.8123 6.99984 13.8123C7.23595 13.8123 7.43039 13.7359 7.58317 13.5832L9.99984 11.1665ZM9.99984 18.3332C8.84706 18.3332 7.76373 18.1144 6.74984 17.6769C5.73595 17.2394 4.854 16.6457 4.104 15.8957C3.354 15.1457 2.76025 14.2637 2.32275 13.2498C1.88525 12.2359 1.6665 11.1526 1.6665 9.99984C1.6665 8.84706 1.88525 7.76373 2.32275 6.74984C2.76025 5.73595 3.354 4.854 4.104 4.104C4.854 3.354 5.73595 2.76025 6.74984 2.32275C7.76373 1.88525 8.84706 1.6665 9.99984 1.6665C11.1526 1.6665 12.2359 1.88525 13.2498 2.32275C14.2637 2.76025 15.1457 3.354 15.8957 4.104C16.6457 4.854 17.2394 5.73595 17.6769 6.74984C18.1144 7.76373 18.3332 8.84706 18.3332 9.99984C18.3332 11.1526 18.1144 12.2359 17.6769 13.2498C17.2394 14.2637 16.6457 15.1457 15.8957 15.8957C15.1457 16.6457 14.2637 17.2394 13.2498 17.6769C12.2359 18.1144 11.1526 18.3332 9.99984 18.3332Z",
    fill: "#DC2626"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCancel);
export default __webpack_public_path__ + "static/media/ic_cancel.e9cd20163b64aac22cbfd8031de375bc.svg";
export { ForwardRef as ReactComponent };